module.exports = "//cdn.mxpnl.com/static/asset-cache/88744f5d805e9c44bf4b949167a948b3/iron/common/assets/images/charts/table.svg";